<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <identificacoes-ilhas-redes-data-table :items="items" :loading="loading" @rechargeTable="getAll" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import IdentificacoesIlhasRedesService from '@/services/IdentificacoesIlhasRedesService';
  import refreshDataMixins from '@/mixins/refreshDataMixins';
  import IdentificacoesIlhasRedesDataTable from '@/components/perdas-tecnicas/identificacoes-ilhas-redes/IdentificacoesIlhasRedesDataTable';

  export default {
    components: {
      IdentificacoesIlhasRedesDataTable
    },
    mixins: [refreshDataMixins],
    data: () => ({
      items: [],
      loading: false
    }),
    created() {
      this.refreshData(this.getAll);
    },
    methods: {
      getAll() {
        this.loading = true;
        IdentificacoesIlhasRedesService.listar()
          .then(({ data }) => (this.items = data.data))
          .finally(() => (this.loading = false));
      }
    }
  };
</script>
